import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '@app/core/services/nav.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  standalone: false,
})
export class SettingsComponent {
  constructor(
    public navService: NavService,
    private router: Router,
  ) {}

  onBack(): void {
    this.navService.closeSettings();
    this.navService.closeMobileMenu();

    const lastRoute: string = this.navService.lastMainRoute();
    if (lastRoute) {
      this.router.navigate([lastRoute]);
    } else {
      this.router.navigate(['/account/dashboard']);
    }
  }
}
